export var BrandedNotificationWorkflowSubTypes;
(function (BrandedNotificationWorkflowSubTypes) {
    BrandedNotificationWorkflowSubTypes["WELCOME"] = "WELCOME";
    BrandedNotificationWorkflowSubTypes["REQUEST_PHOTOS"] = "RP";
    BrandedNotificationWorkflowSubTypes["UPLOAD"] = "UPLOAD";
    BrandedNotificationWorkflowSubTypes["ESTIMATE_UPLOAD"] = "ESTIMATEUPLOAD";
    BrandedNotificationWorkflowSubTypes["APPLICATION"] = "APPLICATION";
    BrandedNotificationWorkflowSubTypes["CATEGORIES"] = "CATEGORIES";
    BrandedNotificationWorkflowSubTypes["SETTINGS"] = "SETTINGS";
    BrandedNotificationWorkflowSubTypes["PERSONA"] = "PERSONA";
    BrandedNotificationWorkflowSubTypes["ESTIMATOR"] = "ESTIMATOR";
})(BrandedNotificationWorkflowSubTypes || (BrandedNotificationWorkflowSubTypes = {}));
//# sourceMappingURL=BrandedNotificationWorkflowSubTypes.js.map